// Header
function Header() {
    return(
        <header>
            <h1>Detective Pokémon</h1>
        </header>
    );
} 
export default Header;